import { domToReact } from "html-react-parser";
import React from "react";
import { renderToString } from "react-dom/server";
import BannerImage from "../components/BannerImage/bannerImage";
import CollapsibleContent from "../components/CollapsibleContent/CollapsibleContent";
import { createRedirectURL } from "./helperFunctions";
import Stepper from "../components/Stepper/Stepper";
const {
  CLASSES: { COLLAPSIBLE_SECTION, BANNER_IMAGE, STEPPER },
} = require("./constants");
const contentParserOptions = {
  replace: domNode => {
    // add data-blocktype as custom-block only if the content is not part of FAQ Content
    if (
      domNode?.attribs?.["data-blocktype"] ===
      "custom-block"
    ) {
      return <></>;
    }
    // add class names if the content is part of FAQ Content
    if (
      domNode &&
      domNode?.attribs?.class ===
        COLLAPSIBLE_SECTION.SECTION
    ) {
      return collapsibleContentParser(domNode);
    }
    if (
      domNode &&
      domNode?.attribs?.class === STEPPER.CONTAINER
    ) {
      return stepperContentParser(domNode);
    }

    if (domNode?.attribs?.class === BANNER_IMAGE.SECTION) {
      return bannerContentParser(domNode);
    }

    if (
      domNode &&
      domNode.name === "a" &&
      domNode.attribs &&
      domNode.attribs.href
    ) {
      if (domNode.attribs.href[0] === "/") {
        domNode.attribs.href = process.env
          .GATSBY_PATH_PREFIX
          ? "/" +
            process.env.GATSBY_PATH_PREFIX +
            createRedirectURL(domNode.attribs.href)
          : createRedirectURL(domNode.attribs.href);
      }
    }
  },
};

export const collapsibleContentParser = domNode => {
  const content = [];
  let heading = "";
  if (domNode?.children) {
    heading =
      domNode?.children?.[0]?.children?.[0]?.children?.[0]
        ?.data;
    content?.push(
      renderToString(
        domToReact(domNode?.children?.[1]?.children)
      )
    );
  }
  let domNodeTemp = domNode?.next;

  while (domNodeTemp) {
    if (domNodeTemp?.data === "\n\n") {
      domNodeTemp = domNodeTemp?.next;
    } else {
      domNodeTemp = null;
    }
  }
  return (
    <CollapsibleContent
      heading={heading}
      content={content}
    />
  );
};

export const bannerContentParser = domNode => {
  let bannerImgUrl = "";
  try {
    if (domNode?.children) {
      bannerImgUrl = domNode?.children[0]?.children[2]?.children[0]?.attribs.srcset
        ?.split(",")[5]
        ?.split(" ")?.[0];
    }
  } catch {
    console.log("bannerImgUrl not provided correctly");
  }

  return <BannerImage bannerImgUrl={bannerImgUrl} />;
};

export const stepperContentParser = domNode => {
  const contentList = [];
  let content = domNode?.children?.[1].children[0];
  while (content) {
    if (content && content?.children?.length > 0) {
      const htmlContent = renderToString(
        domToReact(content?.children)
      );
      contentList?.push(htmlContent);
      content = content?.next;
    } else if (
      content?.data === "\n\n" ||
      content?.data === "\n\n\n\n"
    ) {
      content = content?.next;
    } else {
      content = null;
    }
  }
  return <Stepper contentList={contentList} />;
};

export default contentParserOptions;
